import { DatastoreInterface } from '@freelancer/datastore/core';
import {
  CurrencyCode,
  generateCurrencyObject,
} from '../currencies/currencies.mock';
import { UserGiveGetDetails } from './user-give-get-details.model';
import { UserGiveGetDetailsCollection } from './user-give-get-details.types';

export async function createUserGiveGetDetails(
  datastore: DatastoreInterface,
  options: GenerateUserGiveGetDetailsOptions,
) {
  const object = generateUserGiveGetDetailsObject(options);
  await datastore.createRawDocument<UserGiveGetDetailsCollection>(
    'userGiveGetDetails',
    object,
  );
  return object;
}

export interface GenerateUserGiveGetDetailsOptions {
  readonly userId: number;
  readonly username: string;
  readonly currencyCode?: CurrencyCode;
}

function generateUserGiveGetDetailsObject({
  userId,
  username,
  currencyCode = CurrencyCode.USD,
}: GenerateUserGiveGetDetailsOptions): UserGiveGetDetails {
  return {
    id: userId.toString(),
    isEligible: true,
    isEmailVerified: true,
    isPhoneVerified: true,
    isChildPaymentVerified: true,
    localizedBonus: 20,
    localizedBonusRequirement: 50,
    referralLink: `/get/${username}`, // FIXME: Does this need the hostname?
    userCurrency: generateCurrencyObject(currencyCode),
  };
}
